import Forgotpassword from './Forgotpassword'

export  default  Forgotpassword